import React from "react";
import Select from "react-select";
import { Search } from "@styled-icons/boxicons-regular";

const Dropdown = ({ searchValue, handleSearch, handleSetLocationValue, locationValue, options }) => {
  return (
    <Select
      classNamePrefix="find-locations-dropdown"
      options={options}
      placeholder="Find locations"
      isClearable
      onInputChange={value => handleSearch(value)}
      inputValue={searchValue}
      value={locationValue}
      onChange={handleSetLocationValue}
      styles={customStyles}
      components={customComponents}
      noOptionsMessage={() => null}
    />
  );
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: "0.5rem",
    paddingLeft: "20px",
    border: state.isFocused ? "border: 1px solid #408BFC" : "1px solid #d9d9d9",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#b3b3b3"
    }
  }),
  input: provided => ({
    ...provided,
    fontSize: "16px"
  }),
  placeholder: provided => ({
    ...provided,
    color: "#a0a0a0"
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "10px 15px",
    fontSize: "14px",
    fontWeight: state.isSelected ? "700" : "400",
    backgroundColor: state.isFocused ? "#F3F8FF" : "#fff",
    color: "#000",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#e6e6e6"
    }
  }),
  menu: provided => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)"
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: "16px"
  }),
  dropdownIndicator: () => ({
    display: "none"
  }),
  indicatorSeparator: () => ({
    display: "none"
  })
};

const customComponents = {
  DropdownIndicator: () => (
    <div style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)" }}>
      <Search color="#a0a0a0" size={16} />
    </div>
  ),
  IndicatorSeparator: null
};

export default Dropdown;
